package com.neurobs.react

import scala.scalajs.js

object StyleUtil {

	def makeStyle(attributes: (String, js.Any)*) = {
		js.Dynamic.literal.applyDynamic("apply")(attributes: _*)
	}

	def visibleStyle(visible: Boolean, displayType: String = "block") =
		makeStyle(("display", if (visible) displayType else "none"))
}
